export default theme => ({
    rootDiv: {
        backgroundColor: '#eeeeee'
    }
})